import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../services/auth.service';
import { authUser } from '../../../interfaces';
import { StrategicPillarComponent } from '../../strategic-pillar/strategic-pillar.component';

@Component({
  selector: 'app-strategy-admin-home',
  standalone: true,
  imports: [ButtonModule, StrategicPillarComponent],
  templateUrl: './strategy-admin-home.component.html',
  styleUrl: './strategy-admin-home.component.scss'
})
export class StrategyAdminHomeComponent implements OnInit {
  user!: authUser;
  constructor(private router: Router, private authService: AuthService) {



  }
  ngOnInit(): void {
    this.authService.authBufferSub$.subscribe((user) => {
      this.user = user as authUser;
    })

  }
  gotoAddStrategy() {
    this.router.navigate(['createStrategy', 0]);

  }
}
